module.exports = __webpack_public_path__ + "public/img/mxscl.4d5f2596.png";